import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { canCreateProject as canCreateFromInfo } from '../components/ProjectLimitBanner';

/**
 * 專案數量限制狀態（照 CRM useCustomerLimitCache）：從 ProjectLimitBanner 的 localStorage 快取初始化，按鈕不會先亮再變灰
 */
export const useProjectLimitCache = () => {
  const userContext = useContext(UserContext);
  const { user } = userContext!;

  const readCache = () => {
    if (!user?.organizationId) return null;
    try {
      const cached = localStorage.getItem(`project-limit-${user.organizationId}`);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null; // 快取讀取失敗，使用預設值
    }
  };

  // 未超過上限（資料匯入用）
  const [canAddProject, setCanAddProject] = useState<boolean>(() => readCache()?.isWithinLimit ?? true);

  // 還能新增專案（等於上限就不行；專案列表的新增按鈕用）
  const [canCreateProject, setCanCreateProject] = useState<boolean>(() => {
    const info = readCache();
    return info ? canCreateFromInfo(info) : true;
  });

  // ProjectLimitBanner 刷新觸發器
  const [limitBannerRefreshTrigger, setLimitBannerRefreshTrigger] = useState(0);

  return {
    canAddProject,
    setCanAddProject,
    canCreateProject,
    setCanCreateProject,
    limitBannerRefreshTrigger,
    setLimitBannerRefreshTrigger,
  };
};
